import { Container, Divider, Header, SummaryGroup, useAlignments, useSizes } from 'metrix-common3';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Resident from './Resident';

const ProfileResidents = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('summary');
    const [current, setCurrent] = useState(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicy();
    }, []);

    const getResidents = () => {
        const residents = [];

        if (props.policy?.residents && props.policy.residents.length > 0) {
            props.policy.residents.forEach((resident) => {
                const option = { code: 'resident', value: resident.guid };

                let residentName = (
                    <FormattedMessage
                        key={resident.guid}
                        id='Profile_Residents.resident'
                        values={{ number: resident.number || '' }}
                    />
                );

                if (resident.party?.name) {
                    residentName = `${resident.party.name.firstName} ${resident.party.name.lastName}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: residentName });

                residents.push(option);
            });
        }

        return residents;
    };

    const residents = getResidents();
    return (
        <Container>
            {mode === 'summary' && (
                <React.Fragment>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Residents.residents' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameters([]);
                                props.doExecutePolicyAction({ code: 'CREATERESIDENT' });
                            }}
                            allowEdit
                            editEvent={(resident) => {
                                setCurrent(resident);
                                setMode('resident');
                                props.doReduceParameters([{ code: 'Resident', value: resident }]);
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(resident) => {
                                props.doReduceParameters([{ code: 'Resident', value: resident }]);
                                props.doExecutePolicyAction({ code: 'DELETERESIDENT' });
                            }}
                            entities={residents}
                            icon='person'
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'resident' && (
                <Resident
                    resident={props.policy.residents.find((x) => x.guid === current)}
                    dotProp={`residents.${props.policy.residents.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('summary');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReduceParameter={props.doReduceParameter}
                    doReducePolicyElement={props.doReducePolicyElement}
                    doExecutePolicyAction={props.doExecutePolicyAction}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
        </Container>
    );
};

export default ProfileResidents;
